<div class="modal common-right-modal d-block" id="AddInsurance" aria-hidden="true"
    aria-labelledby="exampleModalToggleLabel" tabindex="-1" style="display: block;" role="dialog"
    [ngClass]="{'show':showSlider}">
    <div class="modal-dialog modal-large">
        <div class="modal-content">
            <div class="modal-header">
                <div class="title-head d-flex align-items-center">
                        <button id="btnAddGroupClose" type="button" class="btn-close tool-wrap position-relative" data-bs-dismiss="modal"
                    (click)="closeBtn()" aria-label="Close">
                    <div class="custom-tooltip tooltip-top" role="tooltip">
                        <div class="arrow"></div>
                        <div class="tooltip-inner"> Close </div>
                      </div></button>
                    <h2 class="modal-title" id="exampleModalToggleLabel">{{addOrEdit}}</h2>
                </div>
                <div class="btn-wrap">

                    <button id="btninsCancel" type="button" class="btn btn-outline-secondary"
                        (click)="closeBtn()" [ngClass]="{'disabled' : isLoader}">Cancel</button>
                    <button id="btninsSave" type="button" class="btn btn-primary" [disabled]="showDetailView || isLoader"
                        (click)="saveForm()">Save</button>
                </div>
            </div>
            <div class="inner-loader-wraper" *ngIf="isLoader">
                <div class="inner-loader"></div>
            </div>
            <div class="modal-body insurance-modal" *ngIf="!isLoader">
                <div class="accordion">
                    <ng-container [formGroup]="insuranceMngmtForm">
                        <app-company-details formGroupName="companyDetailsForm" [isEdit]='isEdit'
                            (isThirdPartyComp)="isThirdPartyCompany()" [submitted]="formSubmitted">
                        </app-company-details>
                        <app-company-address formGroupName="addressForm" [submitted]="formSubmitted"
                            [states]="stateList" [city]="cityList">
                        </app-company-address>

                        <app-prov-contact formGroupName="contactForm" [isEdit]='isEdit' [formSubmitted]="formSubmitted"
                            [userIdExists]="isUser" [isPayer]="true"></app-prov-contact>
                        <app-company-regulator formGroupName="regulatorForm" [submitted]="formSubmitted">
                        </app-company-regulator>
                        <app-credentials formGroupName="credentialsForm" [isEdit]='isEdit' [submitted]="formSubmitted">
                        </app-credentials>
                        <app-payer-cap-integration [submitted]="formSubmitted"></app-payer-cap-integration>
                    </ng-container>


                    <div class="col-12" *ngIf="isThirdPartyComp">
                        <div class="tariff-form mb-3">
                            <div class="row">
                                <div class="col-12">
                                    <div class="tab-section tp-tab">
                                        <div class="tab-slider">
                                            <ul class="nav nav-tabs" role="tablist" id="moving-tabs">
                                                <div class="slider" style="left: 0px; width: 90.9688px;"></div>
                                                <li class="nav-item" role="presentation" #focusedElement
                                                    *ngFor="let item of companyDetails; let i = index;">
                                                    <a class="nav-link " [ngClass]="{'active': tabActive === i }"
                                                        id="CDetails-tab" data-bs-toggle="tab"
                                                        data-bs-target="#CDetails" role="tab" aria-controls="home"
                                                        aria-selected="true" (click)="selectItem(item)">Company details
                                                        {{i+1}} <span (click)="closeThirdParty(i)"><img
                                                                src="assets/images/icons/close.svg" alt=""></span></a>
                                                </li>
                                                <li class="nav-item" role="presentation"><a class="nav-link "></a></li>
                                            </ul>
                                            <div class="right-area-tab d-flex align-items-center">
                                                <div class="scroll-buttons">
                                                    <a class="scroll-left" [ngClass]="{'disabled': tabActive == 0}"
                                                        (click)="focusPreviousTicket()"></a>
                                                    <a class="scroll-right"
                                                        [ngClass]="{'disabled': tabActive == companyDetails.length-1}"
                                                        (click)="focusNextTicket()"></a>
                                                </div>
                                                <div class="add-company-link">
                                                    <a (click)="onAddThirdParty()"><img
                                                            src="./assets/images/icons/plus-icon.svg"
                                                            alt="plus icon">ADD
                                                        COMPANY</a>
                                                </div>
                                            </div>
                                        </div>
                                        <div *ngFor="let item of companyDetails; let i = index;">
                                            <div *ngIf="tabActive === i" [formGroup]="companyDetails[tabActive]">
                                                <div class="tab-content" id="myTabContent">
                                                    <app-company-details formGroupName="companyDetailsForm"
                                                        [isThirdPartyComp]="isThirdPartyComp"
                                                        [submitted]="formSubmitted" [uniQueId]="i+'comp'">
                                                    </app-company-details>
                                                    <app-company-address formGroupName="addressForm"
                                                        [submitted]="formSubmitted"
                                                        [isThirdPartyComp]="isThirdPartyComp" [uniQueId]="i">
                                                    </app-company-address>
                                                    <app-prov-contact formGroupName="contactForm" [isEdit]='isEdit'
                                                        [formSubmitted]="formSubmitted" [userIdExists]="isUserTpa"
                                                        [isThirdPartyComp]="isThirdPartyComp">
                                                    </app-prov-contact>
                                                    <app-company-regulator formGroupName="regulatorForm"
                                                        [submitted]="formSubmitted"
                                                        [isThirdPartyComp]="isThirdPartyComp" [uniQueId]="i">
                                                    </app-company-regulator>
                                                    <app-credentials formGroupName="credentialsForm"
                                                        [submitted]="formSubmitted"
                                                        [isThirdPartyComp]="isThirdPartyComp">
                                                    </app-credentials>
                                                    <app-payer-cap-integration [submitted]="formSubmitted"></app-payer-cap-integration>


                                                    <div class="tab-pane with-scroll fade" id="CDetails1"
                                                        role="tabpanel" aria-labelledby="CDetails1-tab">

                                                    </div>
                                                    <div class="tab-pane with-scroll fade" id="CDetails2"
                                                        role="tabpanel" aria-labelledby="CDetails2-tab">

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>